module.exports = Konva;


//////////////////
// WEBPACK FOOTER
// external "Konva"
// module id = 2
// module chunks = 1 2